export const emailReducer = (state = {}, action) => {
  switch (action.type) {
    case "EMAIL_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        emails: null,
      };
    case "EMAIL_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        emails: action.payload,
      };
    case "EMAIL_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "EMAIL_ADD_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isAdded: false,
      };
    case "EMAIL_ADD_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isAdded: true,
      };
    case "EMAIL_ADD_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAdded: false,
      };

    case "EMAIL_UPDATE_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isUpdated: false,
      };
    case "EMAIL_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isUpdated: true,
      };
    case "EMAIL_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isUpdated: false,
      };

    case "EMAIL_REMOVE_REQUEST":
      return {
        ...state,
        loading: true,
        isDeleted: false,
      };
    case "EMAIL_REMOVE_SUCCESS":
      return {
        ...state,
        loading: false,
        isDeleted: true,
      };
    case "EMAIL_REMOVE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isDeleted: false,
      };

    case "SET_FETCHED_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
